export default __webpack_public_path__ + "device_stick_up_cam_battery_3.a608ed1c.png";